import PasswordGroup from "./PasswordGroup";

export default PasswordGroup;
